import { render, staticRenderFns } from "./MainBookCompCreate.vue?vue&type=template&id=3651f5ad"
import script from "./MainBookCompCreate.vue?vue&type=script&lang=js"
export * from "./MainBookCompCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports